var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeoFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000.74 1028.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 60.88,
    y1: 953.85,
    x2: 939.85,
    y2: 74.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3e17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edd433"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ic\\xF4ne"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "App_Icon_Placeholder",
    "data-name": "App Icon Placeholder",
    className: "cls-2",
    d: "m349.03.5h302.65c100.37,0,150.54,0,204.56,17.56,58.98,22.07,105.44,69.83,126.9,130.46,17.09,55.54,17.09,107.12,17.09,210.29v311.11c0,103.18,0,154.75-17.09,210.29-21.46,60.64-67.92,108.39-126.9,130.46-54.02,17.56-104.19,17.56-204.56,17.56h-302.65c-100.36,0-150.52,0-204.54-17.56-58.98-22.06-105.44-69.82-126.9-130.46C.5,824.67.5,773.09.5,669.92v-311.11c0-103.17,0-154.74,17.09-210.29C39.05,87.88,85.5,40.13,144.49,18.06,198.51.5,248.68.5,349.03.5h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m612.51,622.44l48.6-12.52,88.12,149.24-149.24-88.12,12.51-48.6Zm-29.59-29.59v21.66s-78.14,303.45-78.14,303.45l-78.14-303.45.12-25.83,106-152,71.82-.11,303.45,78.14-303.45,78.14h-21.67Zm29.59-185.87l-12.51-48.6,149.24-88.12-88.12,149.24-48.6-12.51Zm-215.46,0l-48.6,12.52-88.12-149.24,149.24,88.12-12.51,48.6Zm29.59,7.93l78.14-303.45,78.14,303.45-.15,29.77-150,149-27.79-.83-303.45-78.14,303.45-78.14h21.67v-21.66m-29.59,207.53l12.51,48.6-149.24,88.12,88.12-149.24,48.6,12.51Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoFlag);
export default __webpack_public_path__ + "static/media/geoFlag.28ec6ea22b8db25438b4704e8a4c8a71.svg";
export { ForwardRef as ReactComponent };